<template>
  <div>
      <Nav></Nav>
      <Banner></Banner>
  </div>
</template>

<script>
export default {
  components: {
     Nav: () => import("@/components/PublicComponents/Mobile/Nav/Nav.vue"),
      Banner: () => import("@/components/Mobile/Index/Banner/Banner.vue"),
 
  }
}
</script>

<style>

</style>